module.exports = __webpack_public_path__ + "img/show-content-image1.438290b9.png";